module.exports = __webpack_public_path__ + "static/media/User-white.8537fcb9.svg";